import React from 'react';

import { useCustomContentTypes } from '@lumapps/content-types/hooks/useCustomContentTypes';
import { isNewContributionExperienceEnabled, isNewWriterEditorEnabled } from '@lumapps/contents/ducks/selectors';
import { useSelector } from '@lumapps/redux/react';

import { useSpace } from '../../hooks/useSpace';
import { SpaceContentContributionMenu } from './SpaceContentContributionMenu';

const ConnectedSpaceContentContributionMenu: React.FC = () => {
    const { id: spaceId } = useSpace();
    const {
        allowedCustomContentTypes,
        parentCustomContentTypes,
        canDesignAuthorizations,
        isAllowed,
        isLoading,
        isSuperAdmin,
    } = useCustomContentTypes({});

    const isNewContributionExperienceFFEnabled = useSelector(isNewContributionExperienceEnabled);
    const isWriterEditorFFEnabled = useSelector(isNewWriterEditorEnabled);

    if (!spaceId) {
        return null;
    }

    // Check access: user must be allowed or super admin
    const hasAccess = isAllowed || isSuperAdmin;
    if (!hasAccess) {
        return null;
    }

    return (
        <SpaceContentContributionMenu
            spaceId={spaceId}
            allowedCustomContentTypes={allowedCustomContentTypes}
            isSuperAdmin={isSuperAdmin}
            parentCustomContentTypes={parentCustomContentTypes}
            isLoadingCustomContentTypes={isLoading}
            canDesignAuthorizations={canDesignAuthorizations}
            isNewWriterEditorEnabled={isWriterEditorFFEnabled}
            isNewContributionExperienceEnabled={isNewContributionExperienceFFEnabled}
        />
    );
};

export { ConnectedSpaceContentContributionMenu as SpaceContentContributionMenu };
